import http from "../../../network/HTTPClient";

const LeaveRepository = {
  async getTotalAnualLeave() {
    const response = await http.post("leave/getTotalAnualLeave");
    return response.data;
  },

  async updateSettings(data) {
    const response = await http.post("leave/updateSettings", data);
    return response.data;
  },

  async getEmployees() {
    const response = await http.post("employee/getAllNoFilter");
    return response.data;
  },

  async getEmployeesActive() {
    const response = await http.post("employee/getAll");
    return response.data;
  },

  async getTypes() {
    const response = await http.post("leave/getTypes");
    return response.data;
  },

  async getFineTypes() {
    const response = await http.post("leave/getFineTypes");
    return response.data;
  },

  async insert(values) {
    const response = await http.post("leave/insert", values);
    return response.data;
  },
  async update(key, values) {
    const response = await http.post("leave/update", {
      id: key,
      values: values,
    });

    return response.data;
  },
  async delete(key) {
    const response = await http.post("leave/delete", { id: key });

    return response.data;
  },

  async all() {
    const response = await http.post("leave/all");
    return response.data;
  },
};

export default LeaveRepository;
